yalwa.external_link = (function(pub) {
    "use strict";
    
    pub = pub || {};
    
    pub.init = function() {
        const $plp = jQuery('.js-external_link_plp');
        if ($plp.length && yalwa.v.all_tlds) {
            const plp_modal = $plp.find('.plp__modal');
            const buttons = plp_modal.children('span');
            plp_modal.append(buttons.get().reverse());
            
            // RexExp for country tld filtration
            const all_tlds = yalwa.v.all_tlds;
            const tld_pattern = all_tlds.map(tld => tld).join("|");
            const tld_regex = new RegExp(`^(www\.)?(${tld_pattern})$`, 'i');

            jQuery(document).on('click', '.js-external_links', function(e) {
                const $this = jQuery(this);
                const $link = $this.attr('href');
                const parsed_url = new URL($link);
                
                if ($link && !tld_regex.test(parsed_url.hostname)) {
                    e.preventDefault();
                    e.stopPropagation();
                    yalwa.basics.ga.event({category: 'external_link', action: 'views'});
                   $plp.find('.plp__text .yc-em2:first-of-type').html(() => {
						const rawLink = $link.replace(/^(?:https?:\/\/)?(?:[^\/]+\.)?([^.\/]+\.[^.\/]+).*$/, "$1");
						// Truncate to 20 characters if it's longer
						const displayLink = rawLink.length > 40 ? rawLink.slice(0, 40) + "..." : rawLink;
						
						return `<div style="color: #F19F39;">${displayLink}</div>`;
					});
                    $plp.trigger('plp_show');
                    const $clicked_element = jQuery(this);
                    $plp.find('.js-plp_confirm').off('click').on('click', function() {
                        yalwa.basics.ga.event({category: 'external_link', action: 'leave_locanto'});
                        if ($this.hasClass('js-viptrack')) {
                            yalwa.basics.ajaxservice({
                                type: 'PUT',
                                resource: 'vip',
                                action: 'url_click',
                                identifier: yalwa.basics.get_msgID(),
                                csrf: $this.data('vip')
                            }).then(() => {
                                if (yalwa.v.is_phonegap) {
                                    if ($clicked_element.hasClass('js-app_intent')) {
                                        yalwa.mobile.cordova.openintent($link);
                                    } else {
                                        yalwa.mobile.cordova.openexternal($link);
                                    }
                                } else {
                                    yalwa.basics.new_tab($link);
                                }
                            });
                        } else {
                            if (yalwa.v.is_phonegap) {
                                if ($clicked_element.hasClass('js-app_intent')) {
                                    yalwa.mobile.cordova.openintent($link);
                                } else {
                                    yalwa.mobile.cordova.openexternal($link);
                                }
                            } else {
                                yalwa.basics.new_tab($link);
                            }
                        }
                    });
                    
                    $plp.find('.js-plp_ok').off('click').on('click', function() {
                        yalwa.basics.ga.event({category: 'external_link', action: 'stay_on_locanto'});
                    });
                }
            });
        }
    };

    return pub;
}(yalwa));

yalwa.external_link.init();